import { Table, Modal } from "antd";
import { ColumnType } from "antd/lib/table";
import { formatDate } from "../helpers/format";
import useFetchList from "../hooks/useFetchList";
import {
	ETransferEmployeeStatus,
	ETransferEmployeeType,
	ListTransferEmployeeQuery,
	TransferEmployeeProperties,
} from "../types/transferEmployee.type";
import CustomPagination from "./CustomPagination";
import { useEffect } from "react";
import { renderRoles } from "../helpers/renderRoles";
import { EEmployeeRole } from "../types/employee.type";
import NotSet from "./NotSet";

interface UserTransferHistoryProps {
	title?: string;
	userId?: string;
	open?: boolean;
	onClose?: () => void;
}
const UserTransferHistory: React.FC<UserTransferHistoryProps> = ({ userId, open, onClose, title }) => {
	const { isLoading, data, pagination, query, setQuery, changePage } = useFetchList<
		TransferEmployeeProperties,
		ListTransferEmployeeQuery
	>({
		endpoint: "transfer-employees",
		fetchable: userId === undefined ? false : true,
		initialQuery: {
			sort: "createdAt:DESC",
			filterUserId: userId,
			includeData: "originOffice,toOffice",
			filterStatus: ETransferEmployeeStatus.TRANSFERED,
		},
	});

	useEffect(() => {
		if (userId) {
			setQuery({
				...query,
				filterUserId: userId,
			});
		}

		// eslint-disable-next-line
	}, [userId]);

	const COLUMNS: ColumnType<TransferEmployeeProperties>[] = [
		{
			title: "FROM OFFICE",
			key: "originOffice",
			dataIndex: ["originOffice", "officeName"],
		},
		{
			title: "TO OFFICE",
			key: "toOffice",
			dataIndex: ["toOffice", "officeName"],
		},
		{
			title: "TRANSFERRED AT",
			key: "transferedAt",
			dataIndex: "scheduledAt",
			render: (value: string, record: TransferEmployeeProperties) => {
				if (record.type === ETransferEmployeeType.SCHEDULED) {
					return formatDate(value);
				}
				return formatDate(record.updatedAt);
			},
		},
		{
			title: "TRANSFERRED BY",
			key: "transferedBy",
			dataIndex: ["createdByUserMeta", "name"],
			render(value, record) {
				return (
					<>
						{value} (Roles:{" "}
						{record.createdByUserMeta?.actionRoleUser && record.createdByUserMeta?.actionRoleUser ? (
							renderRoles(record.createdByUserMeta.actionRoleUser.split(",") as EEmployeeRole[])
						) : (
							<NotSet />
						)}
						)
					</>
				);
			},
		},
	];

	return (
		<Modal
			title={title ?? "History Transfer"}
			open={open}
			onCancel={onClose}
			destroyOnClose={true}
			width={755}
			footer={null}
		>
			<Table
				className="table-grey-header"
				loading={isLoading}
				columns={COLUMNS}
				dataSource={data}
				rowKey="transferEmployeeId"
				pagination={false}
			/>
			<CustomPagination
				current={pagination.page}
				total={pagination.totalData}
				defaultPageSize={pagination.perPage}
				pageSize={pagination.perPage}
				onChange={changePage}
			/>
		</Modal>
	);
};
export default UserTransferHistory;
